import { Box } from "@mui/material";
import { where } from "firebase/firestore";
import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useMicrospecThemeLanguageContext } from "../../MicrospecDynamicUI/Themes";
import FirebaseTitledCardsWithCTAButtonSection from "../Components/FirebaseTitledCardsWithCTAButtonSection";
import { PRODUCTS_COLLECTION } from "../constants/collectionPaths";

const ProductsPage: React.FC = () => {
    const { category_id } = useParams<{ category_id: string }>();
    const { localizationProvider } = useMicrospecThemeLanguageContext();

    const queryConstraints = useMemo(
        () => (category_id ? [where('category_id', '==', category_id)] : []),
        [category_id],
    );

    const mapDocToCard = useCallback((doc: any) => {
        const quantityLabel = doc.quantity_label
            ? localizationProvider.translate(doc.quantity_label) ?? ''
            : '';
        // add shekel to the price
        const secondarySubtitle =
            doc.price != null
                ? `₪${doc.price?.toFixed(2) ?? '0.00'}${quantityLabel ? ` / ${quantityLabel}` : ''}`
                : undefined;
        return {
            id: doc.id,
            image: doc.images?.[0],
            title: localizationProvider.translate(doc.name) ?? '',
            href: `/category/${category_id}/products/${doc.id}`,
            primarySubtitle: doc.description
                ? localizationProvider.translate(doc.description) ?? undefined
                : undefined,
            secondarySubtitle,
            actionButton: {
                label: localizationProvider.translate({ type: 'Internal', text: 'common.viewDetails' }) ?? 'פרטים',
                href: `/category/${category_id}/products/${doc.id}`,
            },
        };
    }, [localizationProvider, category_id]);

    return (
        <Box>
            <FirebaseTitledCardsWithCTAButtonSection spec={{
                collectionPath: PRODUCTS_COLLECTION,
                queryConstraints,
                mapDocToCard,
                id: 'products',
                sectionTitle: {
                    localizationObject: {
                        type: 'Literal',
                        text: 'מוצרים'
                    }
                },
            }} />
        </Box>
    );
};

export default ProductsPage;
